import { render, staticRenderFns } from "./Checkboxs.vue?vue&type=template&id=e42730b6"
import script from "./Checkboxs.vue?vue&type=script&lang=js"
export * from "./Checkboxs.vue?vue&type=script&lang=js"
import style0 from "./Checkboxs.vue?vue&type=style&index=0&id=e42730b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports